/**
 * Minimal DXF (R12) writer for laser-cutter cut lines.
 *
 * Cut silhouettes are exported as closed POLYLINE entities on a `CUT` layer,
 * in MILLIMETRES with the Y axis flipped to DXF's y-up convention. R12
 * POLYLINE/VERTEX/SEQEND is the most widely-imported dialect (CorelDRAW,
 * AutoCAD, every cutter controller we know of reads it).
 */

export interface DxfPolyline {
  points: Array<[number, number]>;
  closed: boolean;
}

const LAYER = 'CUT';

function num(n: number): string {
  return String(Math.round(n * 1000) / 1000);
}

/** Serialize polylines (already in output units and orientation) to DXF. */
export function buildDxf(polylines: DxfPolyline[]): string {
  const lines: string[] = [
    '0',
    'SECTION',
    '2',
    'HEADER',
    '9',
    '$INSUNITS',
    '70',
    '4', // millimetres
    '0',
    'ENDSEC',
    '0',
    'SECTION',
    '2',
    'ENTITIES',
  ];

  for (const poly of polylines) {
    if (poly.points.length < 2) continue;
    lines.push('0', 'POLYLINE', '8', LAYER, '66', '1', '70', poly.closed ? '1' : '0');
    for (const [x, y] of poly.points) {
      lines.push('0', 'VERTEX', '8', LAYER, '10', num(x), '20', num(y));
    }
    lines.push('0', 'SEQEND');
  }

  lines.push('0', 'ENDSEC', '0', 'EOF');
  return lines.join('\n') + '\n';
}
